var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExclaimationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_246_3945)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22.5C14.7848 22.5 17.4555 21.3938 19.4246 19.4246C21.3938 17.4555 22.5 14.7848 22.5 12C22.5 9.21523 21.3938 6.54451 19.4246 4.57538C17.4555 2.60625 14.7848 1.5 12 1.5C9.21523 1.5 6.54451 2.60625 4.57538 4.57538C2.60625 6.54451 1.5 9.21523 1.5 12C1.5 14.7848 2.60625 17.4555 4.57538 19.4246C6.54451 21.3938 9.21523 22.5 12 22.5V22.5ZM12 24C15.1826 24 18.2348 22.7357 20.4853 20.4853C22.7357 18.2348 24 15.1826 24 12C24 8.8174 22.7357 5.76516 20.4853 3.51472C18.2348 1.26428 15.1826 0 12 0C8.8174 0 5.76516 1.26428 3.51472 3.51472C1.26428 5.76516 0 8.8174 0 12C0 15.1826 1.26428 18.2348 3.51472 20.4853C5.76516 22.7357 8.8174 24 12 24V24Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5031 16.5001C10.5031 16.3031 10.5419 16.108 10.6172 15.926C10.6926 15.744 10.8031 15.5787 10.9424 15.4394C11.0817 15.3001 11.247 15.1896 11.429 15.1142C11.611 15.0389 11.8061 15.0001 12.0031 15.0001C12.2 15.0001 12.3951 15.0389 12.5771 15.1142C12.7591 15.1896 12.9244 15.3001 13.0637 15.4394C13.203 15.5787 13.3135 15.744 13.3889 15.926C13.4643 16.108 13.5031 16.3031 13.5031 16.5001C13.5031 16.8979 13.345 17.2794 13.0637 17.5607C12.7824 17.842 12.4009 18.0001 12.0031 18.0001C11.6052 18.0001 11.2237 17.842 10.9424 17.5607C10.6611 17.2794 10.5031 16.8979 10.5031 16.5001V16.5001ZM10.6501 7.49255C10.6301 7.30332 10.6501 7.11199 10.7089 6.931C10.7676 6.75 10.8637 6.58338 10.991 6.44193C11.1183 6.30049 11.2739 6.18739 11.4478 6.10998C11.6216 6.03256 11.8098 5.99255 12.0001 5.99255C12.1903 5.99255 12.3785 6.03256 12.5523 6.10998C12.7262 6.18739 12.8818 6.30049 13.0091 6.44193C13.1364 6.58338 13.2325 6.75 13.2913 6.931C13.35 7.11199 13.37 7.30332 13.3501 7.49255L12.8251 12.7531C12.8074 12.9597 12.7129 13.1522 12.5601 13.2925C12.4073 13.4328 12.2075 13.5106 12.0001 13.5106C11.7926 13.5106 11.5928 13.4328 11.44 13.2925C11.2872 13.1522 11.1927 12.9597 11.1751 12.7531L10.6501 7.49255Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_246_3945"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclaimationCircle);
export default __webpack_public_path__ + "static/media/exclaimationCircle.8bfdf26c83ee23235773cf1c7f68dc6b.svg";
export { ForwardRef as ReactComponent };